import * as React from 'react';
import { CloseOnBlur } from '../close-on-blur';
import { DropdownMenuProps, DropdownMenuState, DropdownMenuContext } from './types';
import { ButtonSecondary } from 'ui';
import * as PropTypes from 'prop-types';
import { OnClickOutside } from '../on-click-outside';

import styles from './dropdown-menu.scss';
import { Handlers, HotKeys, KeyMap } from 'ui/common/hotkeys';
import { keyCodeTypes } from 'ui/common/key-code-types';

export class DropdownMenu extends React.Component<DropdownMenuProps, DropdownMenuState> {
  public state: Readonly<DropdownMenuState> = {
    dropdownExpanded: false
  };

  public static childContextTypes: React.ValidationMap<DropdownMenuContext> = {
    handleDropdownHide: PropTypes.func.isRequired
  };

  public componentDidUpdate(prevProps: DropdownMenuProps, prevState: DropdownMenuState) {
    if (!!this.props.onExpandMenu && this.state.dropdownExpanded && !prevState.dropdownExpanded && !this.props.closeOnDemand) {
      this.props.onExpandMenu();
    }

    if (!!this.props.onCloseMenu && !this.state.dropdownExpanded && prevState.dropdownExpanded) {
      this.setState({ offsetX: 0 });
      this.props.onCloseMenu();
    }

    if (this.props.closeOnDemand === false && !prevProps.closeOnDemand === false) {
      this.setState({ offsetX: 0, dropdownExpanded: false });
    }
  }

  public getChildContext() {
    return {
      handleDropdownHide: this.handleHide
    };
  }

  private handleClick = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    this.setState({
      dropdownExpanded: !this.state.dropdownExpanded
    });
  };

  private handleHide = () => {
    if (this.state.dropdownExpanded) {
      this.setState({
        dropdownExpanded: false
      });
    }
  };

  private keyMap: KeyMap = {
    escapeKey: [keyCodeTypes.Esc]
  };

  private handlerHotkeys: Handlers = {
    escapeKey: () => this.handleHide()
  };

  private onOpenDone = (e: React.AnimationEvent) => {
    const rect = e.currentTarget.getBoundingClientRect();
    if (rect.left < 0) {
      this.setState({ offsetX: -rect.left });
    }
  };

  private setFocus = (element: HTMLElement) => {
    element?.focus();
  };

  public render() {
    const { dropdownExpanded, offsetX } = this.state;
    const onClickHandler = !!this.props.closeAfterClick ? this.handleHide : undefined;

    const menuItem =
      <div className="dropdown-trigger">
        <ButtonSecondary onClick={this.handleClick}>
          {this.props.dropdownNode}
        </ButtonSecondary>
      </div>;

    const adjustmentStyle = offsetX ? { transform: `translateX(${offsetX}px)` } : {};

    return (<div id={this.props.id} className={`dropdown-wrapper ${styles.dropdownWrapper}`}>
      {dropdownExpanded ?
        <HotKeys keyMap={this.keyMap} handlers={this.handlerHotkeys}>
          <OnClickOutside onClickOutside={this.handleHide}>
            <CloseOnBlur onBlur={this.handleHide}>
              <div className={'dropdown'}>
                {menuItem}
                <ul
                  ref={this.setFocus}
                  tabIndex={-1}
                  className={`dropdown-menu ${dropdownExpanded ? 'show' : ''} ${styles.dropdownMenu}`}
                  onClick={onClickHandler}
                  onAnimationEnd={this.onOpenDone}
                  style={adjustmentStyle}>
                  {this.props.children}
                </ul>
              </div>
            </CloseOnBlur>
          </OnClickOutside>
        </HotKeys> : <div className="dropdown">{menuItem}</div>}
    </div>);
  }
}
